import IncludedCoverageApprovalReadOnlyFields from "../components/flexible/IncludedCoverageApprovalReadOnlyFields";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";

export class ResponseRelatedDefaultSectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) {}

	renderBeforeContent(): React.ReactElement {
		return <IncludedCoverageApprovalReadOnlyFields context={this.context} />;
	}
}
